/* bf27 See it in action gallery (R27). One-row looping gallery; see sections/bf27-see-it-on.liquid */

  function bf27gInit(root){
    if(!root||root.dataset.ready)return; root.dataset.ready=1;
    var track=root.querySelector('.bf27g-track'), items=[].slice.call(track.querySelectorAll('.bf27g-item')), chips=[].slice.call(root.querySelectorAll('.bf27g-chip'));
    var bPrev=root.querySelector('.bf27g-prev'), bNext=root.querySelector('.bf27g-next');
    var lb=root.querySelector('[data-lb]'), lbImg=lb.querySelector('img'), lbCap=lb.querySelector('figcaption'), cur=0, last=null;
    var reduced=false; try{reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}
    var looping=false, setW=0, copies=1, idleT=0, lastW=0, drag=null, moved=false;
    document.body.appendChild(lb);
    function vis(){return items.filter(function(i){return !i.hidden;});}
    function gapPx(){var g=parseFloat(getComputedStyle(track).columnGap); return isNaN(g)?12:g;}
    function clearClones(){[].slice.call(track.querySelectorAll('.bf27g-clone')).forEach(function(c){c.parentNode.removeChild(c);});}
    function mk(el){
      var c=el.cloneNode(true); c.classList.add('bf27g-clone'); c.setAttribute('aria-hidden','true'); c.removeAttribute('role'); c.hidden=false;
      c.dataset.src=items.indexOf(el);
      [].slice.call(c.attributes).forEach(function(a){if(a.name.indexOf('data-shopify')===0)c.removeAttribute(a.name);});
      [].slice.call(c.querySelectorAll('button')).forEach(function(b){b.tabIndex=-1;});
      return c;
    }
    function base(){var v=vis(); return v.length?v[0].offsetLeft:0;}
    function arrows(){
      var max=track.scrollWidth-track.clientWidth-2, ov=max>0;
      [bPrev,bNext].forEach(function(b){b.hidden=!ov&&!looping;});
      if(looping){bPrev.disabled=false;bNext.disabled=false;return;}
      bPrev.disabled=track.scrollLeft<=2; bNext.disabled=track.scrollLeft>=max;
    }
    function build(){
      clearClones(); looping=false; track.classList.remove('is-loop'); track.scrollLeft=0; lastW=track.clientWidth;
      var v=vis(); if(!v.length){arrows();return;}
      var V=track.clientWidth, a=v[0], z=v[v.length-1];
      setW=z.offsetLeft+z.offsetWidth-a.offsetLeft+gapPx();
      if(V>0&&setW>=V*1.15){
        looping=true; copies=setW>=3*V?1:2; track.classList.add('is-loop');
        var i,pre=document.createDocumentFragment(),post=document.createDocumentFragment();
        for(i=0;i<copies;i++){v.forEach(function(el){pre.appendChild(mk(el));post.appendChild(mk(el));});}
        track.insertBefore(pre,track.firstChild); track.appendChild(post);
        track.scrollLeft=base();
      }
      arrows();
    }
    function norm(force){
      if(!looping)return;
      var b=base(), rel=track.scrollLeft-b, V=track.clientWidth;
      if(force){ if(rel<0)track.scrollLeft+=setW; else if(rel>=setW)track.scrollLeft-=setW; return; }
      if(rel<-copies*setW+V*0.5) track.scrollLeft+=setW*copies;
      else if(rel>(copies+1)*setW-V*1.5) track.scrollLeft-=setW*copies;
    }
    track.addEventListener('scroll',function(){
      if(looping){norm(false); clearTimeout(idleT); idleT=setTimeout(function(){norm(true);},140);} else arrows();
    },{passive:true});
    function step(dir){
      var f=track.querySelector('.bf27g-item:not([hidden])'); var w=f?f.offsetWidth+gapPx():260;
      var n=Math.max(1,Math.floor(track.clientWidth/w)-1);
      track.scrollBy({left:dir*n*w,behavior:reduced?'auto':'smooth'});
    }
    bPrev.addEventListener('click',function(){step(-1);});
    bNext.addEventListener('click',function(){step(1);});
    track.addEventListener('keydown',function(e){
      if(e.target!==track)return;
      if(e.key==='ArrowRight'){e.preventDefault();step(1);} else if(e.key==='ArrowLeft'){e.preventDefault();step(-1);}
    });
    track.addEventListener('touchstart',function(){track.classList.add('is-touch');},{passive:true});
    track.addEventListener('pointerdown',function(e){
      if(e.pointerType!=='mouse'||e.button!==0)return;
      drag={x:e.clientX,s:track.scrollLeft}; moved=false;
    });
    document.addEventListener('pointermove',function(e){
      if(!drag)return; var dx=e.clientX-drag.x;
      if(!moved&&Math.abs(dx)>5){moved=true;track.classList.add('is-drag');}
      if(moved)track.scrollLeft=drag.s-dx;
    });
    function endDrag(){if(!drag)return; drag=null; track.classList.remove('is-drag'); setTimeout(function(){moved=false;},0);}
    document.addEventListener('pointerup',endDrag); document.addEventListener('pointercancel',endDrag);
    track.addEventListener('click',function(e){if(moved){e.stopPropagation();e.preventDefault();}},true);
    track.addEventListener('dragstart',function(e){e.preventDefault();});
    function filter(f){
      items.forEach(function(i){i.hidden=!(f==='all'||i.dataset.shot===f);});
      chips.forEach(function(c){c.setAttribute('aria-pressed',c.dataset.f===f?'true':'false');});
      build();
    }
    chips.forEach(function(c){c.addEventListener('click',function(){filter(c.dataset.f);});});
    var rt=0; window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){if(track.clientWidth!==lastW)build();},200);});
    function show(i){var v=vis(); if(!v.length)return; cur=(i+v.length)%v.length; var im=v[cur].querySelector('img');
      lbImg.src=im.dataset.full||im.currentSrc||im.src; lbImg.alt=im.alt; lbCap.textContent=im.alt;}
    function open(card){
      var fig=card.closest('.bf27g-item'); if(fig.classList.contains('bf27g-clone'))fig=items[+fig.dataset.src];
      last=fig.querySelector('.bf27g-card'); lb.classList.add('is-open'); document.documentElement.style.overflow='hidden';
      show(vis().indexOf(fig)); lb.querySelector('.x').focus();
    }
    function close(){lb.classList.remove('is-open'); document.documentElement.style.overflow=''; if(last)last.focus({preventScroll:true});}
    track.addEventListener('click',function(e){var c=e.target.closest('.bf27g-card'); if(c)open(c);});
    lb.querySelector('.x').addEventListener('click',close);
    lb.querySelector('.p').addEventListener('click',function(){show(cur-1);});
    lb.querySelector('.n').addEventListener('click',function(){show(cur+1);});
    lb.addEventListener('click',function(e){if(e.target===lb)close();});
    document.addEventListener('keydown',function(e){
      if(!lb.classList.contains('is-open'))return;
      if(e.key==='Escape')close(); else if(e.key==='ArrowLeft')show(cur-1); else if(e.key==='ArrowRight')show(cur+1);
      else if(e.key==='Tab'){var f=[].slice.call(lb.querySelectorAll('button')); var a=document.activeElement,ix=f.indexOf(a);
        if(e.shiftKey&&ix<=0){e.preventDefault();f[f.length-1].focus();}else if(!e.shiftKey&&ix===f.length-1){e.preventDefault();f[0].focus();}}
    });
    var ts=0; lb.addEventListener('touchstart',function(e){ts=e.touches[0].clientX;},{passive:true});
    lb.addEventListener('touchend',function(e){var d=e.changedTouches[0].clientX-ts; if(Math.abs(d)>50)show(cur+(d<0?1:-1));},{passive:true});
    filter('all');
  }
(function(){
  function all(){[].slice.call(document.querySelectorAll('[data-bf27g]')).forEach(bf27gInit);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',all);
})();
